'use client';

import styled from 'styled-components';

import { Spacers } from '@styles/theme';

export const DateInputContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  width: 100%;
  min-width: 0;
`;

export const DateInputWrapper = styled.div`
  position: relative;
  width: 100%;
`;

export const DateTrigger = styled.button<{
  $hasError?: boolean;
  $hasValue?: boolean;
  $isOpen?: boolean;
}>`
  display: flex;
  align-items: center;
  width: 100%;
  height: 2.625rem;
  padding: ${Spacers.SM}rem ${Spacers.BASE}rem;
  padding-left: ${Spacers.XL}rem;
  font-size: ${({ theme }) => theme.typography.body.fontSize};
  font-weight: ${({ theme }) => theme.typography.body.fontWeight};
  font-family: inherit;
  background-color: ${({ theme }) => theme.colors.backgroundAccent};
  border: ${(props) =>
    props.$hasError
      ? `1px solid ${props.theme.colors.statusError}`
      : props.$isOpen
        ? `1px solid ${props.theme.colors.typographyBodyLight}`
        : 'none'};
  border-radius: ${Spacers.XS}rem;
  outline: none;
  cursor: pointer;
  color: ${(props) =>
    props.$hasError
      ? props.theme.colors.statusError
      : props.$isOpen
        ? props.theme.colors.typographyHeadersLight
        : props.theme.colors.typographyBodyLight};
  text-align: left;
`;

export const IconWrapper = styled.div<{ $isOpen?: boolean }>`
  position: absolute;
  top: 50%;
  left: ${Spacers.BASE}rem;
  transform: translateY(-50%);
  display: flex;
  align-items: center;
  justify-content: center;
  pointer-events: none;
  color: ${(props) =>
    props.$isOpen
      ? props.theme.colors.typographyHeadersLight
      : props.theme.colors.typographyBodyLight};
`;

export const CalendarDropdown = styled.div`
  position: absolute;
  top: calc(100% + 0.25rem);
  left: 0;
  z-index: 10;
  background: ${({ theme }) => theme.colors.backgroundLight};
  border-radius: ${Spacers.XS}rem;
  box-shadow: 0 4px 16px hsla(0, 0%, 0%, 0.12);
  padding: ${Spacers.BASE}rem;

  .rdp-root {
    --rdp-accent-color: ${({ theme }) => theme.colors.brand};
    --rdp-accent-background-color: ${({ theme }) => theme.colors.brandAccent};
    --rdp-day-height: 2.25rem;
    --rdp-day-width: 2.25rem;
    --rdp-day_button-height: 2.125rem;
    --rdp-day_button-width: 2.125rem;
    --rdp-day_button-border-radius: ${Spacers.XS}rem;
    --rdp-selected-border: 2px solid ${({ theme }) => theme.colors.brand};
    --rdp-disabled-opacity: 0.4;
    --rdp-outside-opacity: 0.3;
    --rdp-today-color: ${({ theme }) => theme.colors.brand};

    font-family: inherit;
    font-size: ${({ theme }) => theme.typography.body.fontSize};
  }

  .rdp-month_caption {
    font-weight: ${({ theme }) => theme.typography.title.fontWeight};
    font-size: ${({ theme }) => theme.typography.body.fontSize};
    color: ${({ theme }) => theme.colors.typographyHeadersLight};
  }

  .rdp-weekday {
    font-size: 0.75rem;
    font-weight: ${({ theme }) => theme.typography.label.fontWeight};
    color: ${({ theme }) => theme.colors.typographyBodyLight};
  }

  .rdp-day {
    color: ${({ theme }) => theme.colors.typographyHeadersLight};
  }

  .rdp-button_previous,
  .rdp-button_next {
    color: ${({ theme }) => theme.colors.typographyBodyLight};
    border: none;
    cursor: pointer;
    border-radius: ${Spacers.XS}rem;

    &:hover {
      background-color: ${({ theme }) => theme.colors.backgroundAccent};
    }
  }
`;

export const Overlay = styled.div`
  position: fixed;
  inset: 0;
  z-index: 9;
`;
